import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdvisoryPage from "@/pages/AdvisoryPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ThemesIndex from "@/pages/preview/ThemesIndex";
import MidnightPreview from "@/pages/preview/MidnightPreview";
import EditorialPreview from "@/pages/preview/EditorialPreview";
import CyberPreview from "@/pages/preview/CyberPreview";
import { captureUTM } from "@/lib/utm";

function App() {
  useEffect(() => {
    captureUTM();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/advisory" element={<AdvisoryPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/themes" element={<ThemesIndex />} />
          <Route path="/preview/midnight" element={<MidnightPreview />} />
          <Route path="/preview/editorial" element={<EditorialPreview />} />
          <Route path="/preview/cyber" element={<CyberPreview />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
